// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"310c7ec1","239":"cc741abd","732":"a709ae6f","977":"5cfa071f"}[chunkId] + ".chunk.js";
};